<template>
  <div>
    <BaseDrawer>
      <div class="AdvancedSearch">
        <div class="AdvancedSearch_title">
          <i class="AdvancedSearch_title_icon"></i>
          <div class="AdvancedSearch_title_text">高级搜索</div>
        </div>

        <div class="AdvancedSearch_tab">
          <div
            :class="
              activeName == item
                ? 'AdvancedSearch_tab_item AdvancedSearch_tab_item_act'
                : 'AdvancedSearch_tab_item'
            "
            v-for="(item, index) in ['条件搜索', '空间搜索']"
            :key="index"
            @click="handleClick(item)"
          >
            {{ item }}
          </div>
        </div>

        <!-- 搜索框 -->
        <div class="AdvancedSearch_input">
          <input
            type="text"
            placeholder="请输入对象名称"
            :value="inputData"
            @input="onSearchInput"
          />
          <i
            class="AdvancedSearch_input_search"
            @click="inputSearch"
            v-if="!inputData"
          ></i>
          <i class="AdvancedSearch_input_clear" @click="inputClear" v-else></i>
        </div>

        <main class="AdvancedSearch_main">
          <!-- 条件搜索 -->
          <div class="ConditionsSearch" v-if="activeName == '条件搜索'">
            <div class="ConditionsSearch_location">
              <div class="ConditionsSearch_location_text">位置</div>
              <div class="ConditionsSearch_location_Dropdown">
                <div
                  class="ConditionsSearch_location_Dropdown_head"
                  @click="isOpenLocationDropdown"
                >
                  <span>{{ locationSelected }}</span>
                  <i class="ConditionsSearch_location_Dropdown_head_icon"></i>
                </div>
                <ul
                  class="ConditionsSearch_location_Dropdown_list"
                  v-if="isShowLocationDropdown"
                >
                  <li
                    v-for="(item, index) in locationList"
                    :key="index"
                    @click="selectLocationDropdownItem(item)"
                  >
                    {{ item }}
                  </li>
                </ul>
              </div>
              <div
                class="ConditionsSearch_location_button"
                @click="AddCondition"
              >
                <i class="ConditionsSearch_location_button_icon"></i>
                <span>添加条件</span>
              </div>
            </div>

            <div
              class="ConditionsSearch_condition"
              v-for="(item, index) in conditionData"
              :key="index"
            >
              <div class="ConditionsSearch_condition_text">条件</div>
              <div class="ConditionsSearch_condition_Dropdown">
                <div
                  class="ConditionsSearch_condition_Dropdown_head"
                  @click="isOpenConditionDropdown(index)"
                >
                  <span>{{ item.type }}</span>
                  <i class="ConditionsSearch_condition_Dropdown_head_icon"></i>
                </div>
                <ul
                  class="ConditionsSearch_condition_Dropdown_list"
                  v-if="isShowConditionDropdown == index"
                >
                  <li
                    v-for="(ele, i) in item.arr"
                    :key="i"
                    @click="selectConditionDropdownItem(ele, index)"
                  >
                    {{ ele.name }}
                  </li>
                </ul>
              </div>
              <div class="ConditionsSearch_condition_Dropdown">
                <div
                  class="ConditionsSearch_condition_Dropdown_head"
                  @click="isOpenConditionDropdown2(index)"
                >
                  <span>{{ item.childType }}</span>
                  <i class="ConditionsSearch_condition_Dropdown_head_icon"></i>
                </div>
                <ul
                  class="
                    ConditionsSearch_condition_Dropdown_list
                    ConditionsSearch_condition_Dropdown_list2
                  "
                  v-if="isShowConditionDropdown2 == index"
                >
                  <li
                    v-for="(ele, i) in item.children"
                    :key="i"
                    @click="selectConditionDropdownItem2(ele, index)"
                  >
                    {{ ele.name }}
                  </li>
                </ul>
              </div>
              <div
                class="ConditionsSearch_condition_button"
                @click="deleteItem(index)"
              >
                <i class="ConditionsSearch_conditionbutton_icon"></i>
                <span>删除</span>
              </div>
            </div>

            <div class="ConditionsSearch_button">
              <div class="ConditionsSearch_button_search" @click="Search">
                <i></i>
                <span>搜索</span>
              </div>
              <div class="ConditionsSearch_button_clear" @click="clear">
                <i></i>
                <span>清除</span>
              </div>
            </div>
          </div>

          <!--空间搜索-->
          <div class="SpaceCearch" v-if="activeName == '空间搜索'">
            <div class="SpaceCearch_UG">
              <div>U高（U）</div>
              <input type="text" />
            </div>
            <div class="SpaceCearch_location">
              <div class="SpaceCearch_location_text">位置</div>
              <div class="SpaceCearch_location_Dropdown">
                <div
                  class="SpaceCearch_location_Dropdown_head"
                  @click="isOpenSpaceLocationDropdown"
                >
                  <span>{{ SpaceLocationSelected }}</span>
                  <i class="SpaceCearch_location_Dropdown_head_icon"></i>
                </div>
                <ul
                  class="SpaceCearch_location_Dropdown_list"
                  v-if="isShowSpaceLocationDropdown"
                >
                  <li
                    v-for="(item, index) in SpaceLocationList"
                    :key="index"
                    @click="selectSpaceLocationDropdownItem(item)"
                  >
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="SpaceCearch_UG">
              <div>电力（W）</div>
              <input type="text" />
            </div>

            <div class="SpaceCearch_UG">
              <div>承重（KG）</div>
              <input type="text" />
            </div>

            <div class="SpaceCearch_button">
              <div class="SpaceCearch_button_search" @click="Search">
                <i></i>
                <span>确定</span>
              </div>
              <div class="SpaceCearch_button_clear" @click="clear">
                <i></i>
                <span>清除</span>
              </div>
            </div>
          </div>

          <!-- 树形结构 -->
          <div class="tree" v-if="isShowData">
            <el-tree
              class="custom-el-tree"
              node-key="id"
              :ref="architecture.ref"
              :data="architecture.treeData"
              :props="architecture.treeProps"
              :accordion="true"
              :render-content="renderSpaceContent"
              :filter-node-method="filterNode"
              :auto-expand-parent="false"
              @node-click="handleNodeClick"
              :default-expand-all="false"
              :default-expanded-keys="defaultExpandedKeys"
            ></el-tree>
          </div>
        </main>

        <div class="AdvancedSearch_footer" v-if="activeName == '条件搜索'">
          搜索结果：视野内121 视野外175
        </div>
      </div>
    </BaseDrawer>
  </div>
</template>

<script>
import BaseDrawer from '../common/BaseDrawer.vue'
import { mapState } from 'vuex'
import layerMap from '@/utils/configs/layerMap'
import cameraList from '@/utils/configs/cameraList'
import { SpaceListSearch } from './index'
import { SpatialSearch } from './SpatialSearch'
import UEapi from '@/utils/UEapi/UEapi'
import { SpaceList } from '../DuiXiangGuanLi/index'
export default {
  components: {
    BaseDrawer,
  },
  data() {
    return {
      activeNames: 'space',
      activeName: '条件搜索',
      hasInput: true,
      inputData: '',
      //位置选中项
      locationSelected: '机房01',
      //位置数据
      locationList: ['机房01', '机房02', '机房03', '机房04', '机房05'],
      isShowLocationDropdown: false,
      //条件
      conditionSum: 0,
      conditionData: [],
      //条件选中项
      conditionSelected: '所属应用',
      //条件数据
      conditionList: [
        {
          name: '所属应用',
          children: [
            { name: '财务系统' },
            { name: '呼叫中心' },
            { name: '结算系统' },
            { name: '仓储系统' },
            { name: '公共服务' },
            { name: 'OA系统' },
            { name: '采购系统' },
            { name: '测试云服务' },
          ],
        },
        {
          name: '所属部门',
          children: [
            { name: '部门01' },
            { name: '部门02' },
            { name: '部门03' },
            { name: '部门04' },
            { name: '部门05' },
            { name: '部门06' },
            { name: '部门07' },
            { name: '部门08' },
          ],
        },
        {
          name: '所属团队',
          children: [
            { name: '团队01' },
            { name: '团队02' },
            { name: '团队03' },
            { name: '团队04' },
            { name: '团队05' },
            { name: '团队06' },
            { name: '团队07' },
            { name: '团队08' },
          ],
        },
        {
          name: '维保状态',
          children: [
            { name: '状态01' },
            { name: '状态02' },
            { name: '状态03' },
            { name: '状态04' },
            { name: '状态05' },
            { name: '状态06' },
            { name: '状态07' },
            { name: '状态08' },
          ],
        },
        {
          name: '生产状态',
          children: [
            { name: '生产01' },
            { name: '生产02' },
            { name: '生产03' },
            { name: '生产04' },
            { name: '生产05' },
            { name: '生产06' },
            { name: '生产07' },
            { name: '生产08' },
          ],
        },
      ],
      isShowConditionDropdown: -1,
      conditionSelected2: '财务系统',
      conditionList2: [],
      isShowConditionDropdown2: -1,
      SpaceLocationSelected: '机房01',
      //空间搜索-位置数据
      SpaceLocationList: ['机房01', '机房02', '机房03', '机房04', '机房05'],
      isShowSpaceLocationDropdown: false,
      isShowData: false,
      architecture: {
        ref: 'spaceRef',
        treeData: [
          {
            id: '建筑01',
            label: '建筑01',
            children: [
              {
                id: '建筑01-F03',
                label: '建筑01-F03',
                children: [],
                level: '2',
                sort: 1,
                isSelect: true,
                objType: 'space',
                location: '机房03',
                use: '财务系统',
              },
              // {
              //   id: '建筑01-F04',
              //   label: '建筑01-F04',
              //   children: [],
              //   level: '2',
              //   sort: 1,
              //   isSelect: true,
              //   objType: 'space',
              //   location: '机房03',
              //   use: '财务系统'
              // }
            ],
            level: '1',
            sort: 1,
            isSelect: true,
            objType: 'space',
            location: '机房03',
            use: '财务系统',
          },
        ],
        treeProps: {
          children: 'children',
          label: 'label',
        },
      },
      cameraDataList: [], //点位汇总所有摄像头数据
      defaultExpandedKeys: [
        '北京数据中心',
        '分数据中心-01',
        'SM_IDC机房楼',
        'SM_IDC室内04',
        '机柜组机房',
        'C03-004_SM_机柜组',
        'C03-004-04_SM_设备机柜',
        'A01-04_SM_设备机柜',
        'F06-004-07_SM_设备机柜',
        'A01-004_SM_机柜组',
        'F06-004_SM_机柜组',
      ],
      // 机柜ID空间使用
      JGIDKJSYArr: [
        {
          id: 'C03-004-02_空间使用',
          x: -9.152,
          z: 12.6485714285714,
          y: 2.62,
          name: 'C03-004-02_空间使用',
          type: '机柜组',
          category: '可以移动',
          ZScale: 0.246428571428571,
        },
        {
          id: 'C03-004-03_空间使用',
          x: -8.516,
          z: 12.6978571428571,
          y: 2.62,
          name: 'C03-004-03_空间使用',
          type: '机柜组',
          category: '移动困难',
          ZScale: 0.295714285714286,
        },
        {
          id: 'C03-004-04_空间使用',
          x: -7.9,
          z: 12.5992857142857,
          y: 2.62,
          name: 'C03-004-04_空间使用',
          type: '机柜组',
          category: '移动困难',
          ZScale: 0.246428571428571,
        },
        {
          id: 'C03-004-05_空间使用',
          x: -7.27,
          z: 12.7964285714286,
          y: 2.62,
          name: 'C03-004-05_空间使用',
          type: '机柜组',
          category: '移动困难',
          ZScale: 0.0985714285714286,
        },
        {
          id: 'C03-004-06_空间使用',
          x: -6.64,
          z: 12.5007142857143,
          y: 2.62,
          name: 'C03-004-06_空间使用',
          type: '机柜组',
          category: '可以移动',
          ZScale: 0.197142857142857,
        },
        {
          id: 'C03-004-07_空间使用',
          x: -6.02,
          z: 12.55,
          y: 2.62,
          name: 'C03-004-07_空间使用',
          type: '机柜组',
          category: '可以移动',
          ZScale: 0.147857142857143,
        },
        {
          id: 'C03-004-08_空间使用',
          x: -5.4,
          z: 12.7964285714286,
          y: 2.62,
          name: 'C03-004-08_空间使用',
          type: '机柜组',
          category: '移动困难',
          ZScale: 0.0985714285714286,
        },
        {
          id: 'C03-004-09_空间使用',
          x: -4.77,
          z: 12.6978571428571,
          y: 2.62,
          name: 'C03-004-09_空间使用',
          type: '机柜组',
          category: '可以移动',
          ZScale: 0.295714285714286,
        },
        {
          id: 'C03-004-10_空间使用',
          x: -4.13,
          z: 12.7964285714286,
          y: 2.62,
          name: 'C03-004-10_空间使用',
          type: '机柜组',
          category: '可以移动',
          ZScale: 0.295714285714286,
        },
      ],
      ShowJiGuiLayer: true,
      boxLayer: {
        id: 'JiGuiZuLayer-JiGuiZuLayer',
        name: 'JiGuiZuLayer-JiGuiZuLayer',
        legends: [
          {
            name: '不可移动',
            color: '#FF5C30',
            alpha: '0.5',
          },
          {
            name: '移动困难',
            color: '#FF7706',
            alpha: '0.5',
          },
          {
            name: '可以移动',
            color: '#FFDD03',
            alpha: '0.8',
          },
          {
            name: '推荐位置',
            color: '#76D30C',
            alpha: '0.8',
          },
          {
            name: '空闲',
            color: '#029ffd',
            alpha: '0',
          },
        ],
        layerConfig: {
          legends: {
            空闲: {
              name: '空闲',
              color: '#029ffd',
              alpha: '0',
            },
            推荐位置: {
              name: '推荐位置',
              color: '#76D30C',
              alpha: '0.8',
            },
            可以移动: {
              name: '可以移动',
              color: '#FFDD03',
              alpha: '0.8',
            },
            移动困难: {
              name: '移动困难',
              color: '#FF7706',
              alpha: '0.5',
            },
            不可移动: {
              name: '不可移动',
              color: '#FF5C30',
              alpha: '0.5',
            },
          },
          layerType: 'JiGuiZuLayer',
          scatterType: '空间搜索机柜组', // 点位汇总中数据的名称
          jsonPath: '',
          isClick: true,
          status: 'none', // 显示状态 none show hide
          rawData: [], // 原始数据
          jsonData: {}, // 添加时候的数据
        },
      },
    }
  },
  methods: {
    //搜索切换
    handleClick(name) {
      this.activeName = name
      this.isShowData = false
      this.conditionData = []
      this.inputClear()
      this.SpaceLocationSelected = this.spaceLevel
      if (this.activeName == '空间搜索') {
        this.defaultExpandedKeys = []
        window.layerConfig.recoverDefaultState()
        UEapi.Camera.setCamera(cameraList[this.spaceLevel])
        window.layerConfig.hideAllLayer()
      } else {
        window.layerConfig.legendClick({
          txt: 'JiGuiZuLayer',
          highlight: false,
          layers: [`园区-JiGuiZuLayer`],
        })
        window.layerConfig.recoverDefaultState()
        UEapi.Camera.setCamera(cameraList[this.spaceLevel])
        this.defaultExpandedKeys = [
          '北京数据中心',
          '分数据中心-01',
          'SM_IDC机房楼',
          'SM_IDC室内04',
          '机柜组机房',
          'C03-004_SM_机柜组',
          'C03-004-04_SM_设备机柜',
          'A01-04_SM_设备机柜',
          'F06-004-07_SM_设备机柜',
          'A01-004_SM_机柜组',
          'F06-004_SM_机柜组',
        ]
      }
    },
    // 默认展开节点
    // 空间搜索点击确定
    onSearchInput(e) {
      const { target } = e
      setTimeout(() => {
        this.inputData = target.value
      }, 1000)
    },
    // 输入框查询
    inputSearch() {},
    // 输入框清空
    inputClear() {
      this.inputData = ''
      this.isShowData = false
      this.conditionData = []
    },

    //展开位置下拉框
    isOpenLocationDropdown() {
      this.isShowLocationDropdown = !this.isShowLocationDropdown
    },

    //选择位置下拉框中的某一项
    selectLocationDropdownItem(item) {
      this.locationSelected = item
      this.isShowLocationDropdown = false
    },

    //添加条件
    AddCondition() {
      if (this.conditionData.length == this.conditionList.length) return
      this.conditionData.push({
        arr: this.conditionList,
        type: this.conditionList[0].name,
        children: this.conditionList[0].children,
        childType: this.conditionList[0].children[0].name,
      })
    },

    //选择条件下拉框中的某一项
    selectConditionDropdownItem(item, index) {
      let newArr = this.conditionData
      if (this.isShowConditionDropdown == index) {
        newArr[index].type = item.name
        newArr[index].children = item.children
        newArr[index].childType = item.children[0].name
        this.$set(this, 'conditionData', newArr)
      }
      this.isShowConditionDropdown = -1
    },

    isOpenConditionDropdown(index) {
      this.isShowConditionDropdown =
        index == this.isShowConditionDropdown ? -1 : index
    },

    //选择条件下拉框中的某一项
    selectConditionDropdownItem2(item, index) {
      let newArr = this.conditionData
      if (this.isShowConditionDropdown2 == index) {
        newArr[index].childType = item.name
        this.$set(this, 'conditionData', newArr)
      }
      this.isShowConditionDropdown2 = -1
    },

    isOpenConditionDropdown2(index) {
      this.isShowConditionDropdown2 =
        index == this.isShowConditionDropdown2 ? -1 : index
    },

    deleteItem(index) {
      this.conditionData.splice(index, 1)
    },

    //搜索
    Search() {
      if (this.inputData) {
        // this.$store.commit('setHighLight', '机柜点位')

        if (this.activeName == '条件搜索') {
          this.architecture.treeData[0] = SpaceListSearch[0]
          this.defaultExpandedKeys = [
            '北京数据中心',
            '分数据中心-01',
            'SM_IDC机房楼',
            'SM_IDC室内04',
            '机柜组机房',
            'C03-004_SM_机柜组',
            'C03-004-04_SM_设备机柜',
            'A01-04_SM_设备机柜',
            'F06-004-07_SM_设备机柜',
            'A01-004_SM_机柜组',
            'F06-004_SM_机柜组',
          ]
          let arr = [
            {
              layers: ['园区-机柜点位'],
              highlight: true,
            },
          ]
          window.layerConfig.ShowHideLayer(arr)
          this.isShowData = true
        } else {
          this.SpaceLocationSelected.split('_')[2] == '机柜组' &&
            window.layerConfig.equipmentCabinetOnlyHighlight(
              this.SpaceLocationSelected
            )
          this.architecture.treeData[0] = SpatialSearch[0]
          window.layerConfig.legendClick({
            txt: 'JiGuiZuLayer',
            highlight: true,
            layers: [`园区-JiGuiZuLayer`],
          })
          UEapi.Model.setModelVisibility({
            ids: ['C03-004_SM_机柜组'],
            visible: false,
          })
          this.defaultExpandedKeys = [
            '北京数据中心',
            '分数据中心-01',
            'SM_IDC机房楼',
            'SM_IDC室内04',
            '机柜组机房',
            'C03-004_SM_机柜组',
          ]
          this.isShowData = true
        }
        return
        // 列表为真是显示树形结构，晒出来当前spaceLevel下所有摄像头的点位
        switch (this.spaceLevel) {
          case '园区':
          case '楼层':
          case '机柜组机房':
          case 'UPS设备机房':
          case '电池组机房':
            let architectureData = {
              ref: 'spaceRef',
              treeData: [],
            }
            let ArrYQfilter = this.cameraDataList.filter((item) => {
              return item.type == this.spaceLevel
            })
            let ArrYQ = ArrYQfilter.map((item) => {
              return {
                id: item.id,
                label: item.name,
                level: '2',
                sort: 1,
                isSelect: false,
                lon: item.lon,
                lat: item.lat,
                name: item.name,
                type: item.type,
              }
            })
            let names = {
              '园区-固定摄像头': '摄像头-固定',
              '园区-云台摄像头': '摄像头-云台',
              '园区-人脸识别摄像头': '摄像头-人脸识别',
            }
            let obj = layerMap[this.sceneName]
            for (let k in obj) {
              let id = names[k]
              if (k.indexOf('摄像头') != -1) {
                // names[k]
                architectureData.treeData.push({
                  id: names[k],
                  label: k.slice(3),
                  children: [],
                })
              }
            }
            let AllsxtData = architectureData.treeData.map((item, index) => {
              let gdsxt = ArrYQ.filter((f) => {
                if (f.name.indexOf(item.id) != -1) {
                  return f
                }
              })
              architectureData.treeData[index].children = gdsxt
              return architectureData
            })
            // 最终处理完的数据
            // this.architecture.treeData = AllsxtData[0].treeData
            this.architecture.treeData[0].children[0].children =
              AllsxtData[0].treeData
            let arr = [
              {
                layers: ['园区-固定摄像头'],
                highlight: true,
              },
              {
                layers: ['园区-云台摄像头'],
                highlight: true,
              },
              {
                layers: ['园区-人脸识别摄像头'],
                highlight: true,
              },
            ]
            window.layerConfig.ShowHideLayer(arr)
            break
          default:
            break
        }
      }
    },

    //清除
    clear() {
      this.conditionData = []
    },

    //空间搜索-展开位置下拉框
    isOpenSpaceLocationDropdown() {
      this.isShowSpaceLocationDropdown = !this.isShowSpaceLocationDropdown
    },

    selectSpaceLocationDropdownItem(name) {
      this.SpaceLocationSelected = name
      this.isShowSpaceLocationDropdown = false
      if (name == '楼层' || name == '机柜组机房') {
        UEapi.Camera.setCamera(cameraList[this.spaceLevel])
      } else {
      }
    },

    // 树节点点击事件
    handleNodeClick(node) {
      const curTreeRef = this.$refs[`${this.activeNames}Ref`]
      this.$nextTick(() => {
        this.disableHandleExpandIconClick(curTreeRef.$children)
      })
      let { id, label, isSelect } = node
      let idLayer = ''
      let names = {
        '摄像头-固定': '园区-固定摄像头',
        '摄像头-云台': '园区-云台摄像头',
        '摄像头-人脸识别': '园区-人脸识别摄像头',
      }
      console.log(idLayer, isSelect, 987987878998)
      let distance = {
        园区: 10,
        楼层: 10,
        机柜组机房: 5,
        UPS设备机房: 5,
        电池组机房: 4,
      }
      isSelect = !isSelect
      if (isSelect) {
        for (let k in names) {
          if (label.indexOf(k) != -1) {
            idLayer = names[k]
            let jsonData = {
              id: id,
              idLayer: idLayer,
              layerType: 'landmarkLayer',
              distance: distance[this.spaceLevel],
            }
            window.appInstance.uniCall('focusByLayer', jsonData)
          }
        }
      } else {
        isSelect = false
        window.appInstance.uniCall('setCamera', cameraList[this.spaceLevel])
      }
      console.log(node, '点击树形结构某一项')
      const { objType } = node
      const curNode = curTreeRef.getNode(node)
      // 同级手风琴效果
      this.handleAccordion(curNode)
      // 节点是否选中
      node.isSelect = !node.isSelect
      this.selectObjNum = node.isSelect
        ? node?.num || 1
        : curNode?.parent?.data?.num ?? 0
      // 设置节点高亮状态
      curNode.isCurrent = node.isSelect

      this.setExpanded(curNode, node.isSelect)
      !node.isSelect && this.setChildrenCollapse(curNode)
    },

    // 临时解决办法 禁用树结构前面的小三角
    disableHandleExpandIconClick(child) {
      if (child.length > 0) {
        for (let i = 0; i < child.length; i++) {
          child[i].handleExpandIconClick = function () {
            console.log('禁用')
          }
          if (child[i].$children.length > 0) {
            this.disableHandleExpandIconClick(child[i].$children)
          }
        }
      }
    },

    // 自定义空间节点
    renderSpaceContent(h, { node, data, store }) {
      // console.log(data.children.length)
      return (
        <div class="custom-el-tree-node">
          <div class="text">{node.label}</div>
        </div>
      )
    },

    // 设置节点是否展开
    setExpanded(curNode, isSelect) {
      if (curNode.childNodes.length > 0) {
        curNode.expanded = isSelect
      }
    },

    // 树组件点击节点同级手风琴效果
    handleAccordion(curNode) {
      let parent = curNode?.parent ?? null
      if (parent) {
        parent.childNodes.forEach((element) => {
          if (curNode !== element) {
            element.collapse()
            element.data.isSelect = false
          }
        })
      }
    },

    // 节点折叠后设置自己的子节点也折叠
    setChildrenCollapse(curNode) {
      if (curNode.childNodes.length > 0) {
        curNode.childNodes.forEach((element) => {
          element.collapse()
          element.data.isSelect = false
          if (element?.childNodes) {
            this.setChildrenCollapse(element)
          }
        })
      }
    },

    // 树节点过滤
    filterNode(value, data) {
      if (!value) return true
      if (data.label.indexOf(value) !== -1) {
        return data.label.indexOf(value) !== -1
      }
    },
  },
  created() {
    // 所有机柜组数据
    let arr = []
    SpaceList[0].children[0].children[0].children[0].children[0].children[0].children.forEach(
      (item) => {
        arr.push(item.id)
      }
    )
    this.SpaceLocationList = arr
    this.SpaceLocationSelected = this.spaceLevel
    // 所有摄像头点位数据
    let allData = JSON.stringify(window.allData)
    let Data = JSON.parse(allData)
    let cameraDataList = []
    for (let key in Data) {
      if (key.indexOf('摄像头') != -1) {
        Data[key].RECORDS.forEach((item, index) => {
          //
          cameraDataList.push(item)
        })
      }
    }
    this.cameraDataList = cameraDataList
  },
  computed: {
    ...mapState(['spaceLevel', 'sceneName', 'modelId']),
  },
  watch: {
    modelId: {
      handler(v) {
        this.SpaceLocationSelected = v
      },
    },
  },
}
</script>

<style lang="less" scoped>
.AdvancedSearch {
  height: 100%;
  border: 2px solid rgba(146, 172, 186, 0.65);
  background-color: rgba(18, 32, 46, 0.6);
  position: relative;

  .AdvancedSearch_title {
    width: 100%;
    height: 78px;
    display: flex;
    align-items: center;
    border-bottom: solid 2px rgba(255, 255, 255, 0.3);
    padding-left: 30px;
    box-sizing: border-box;
    .AdvancedSearch_title_icon {
      width: 34px;
      height: 34px;
      background: url('../../assets/img/GJSS/GJSS.png') no-repeat 100%;
    }

    .AdvancedSearch_title_text {
      margin-left: 13px;
      color: #fff;
      font-family: '微软雅黑';
      font-weight: bold;
      font-size: 36px;
    }
  }

  .AdvancedSearch_tab {
    width: 100%;
    height: 63px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: solid 2px rgba(255, 255, 255, 0.3);
    padding: 10px 20px 0;
    box-sizing: border-box;

    .AdvancedSearch_tab_item {
      width: 310px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #343538;
      border-radius: 10px;
      color: #fff;
      font-family: '微软雅黑';
      font-size: 28px;
    }

    .AdvancedSearch_tab_item_act {
      background: #189bfa;
    }
  }

  .AdvancedSearch_input {
    width: 100%;
    padding: 12px 20px 0;
    margin-bottom: 10px;
    box-sizing: border-box;
    position: relative;

    & > input {
      width: 100%;
      height: 50px;
      border-radius: 5px;
      border: 2px solid rgb(77, 80, 94);
      color: #fff;
      font-size: 28px;
      background-color: rgb(39, 39, 41);
      padding: 0px 19px 0px 12px;
      box-sizing: border-box;
    }

    & > i {
      position: absolute;
      top: 24px;
      right: 45px;
      width: 24px;
      height: 24px;
    }

    .AdvancedSearch_input_search {
      background: url('../../assets/img/GJSS/SS.png') no-repeat 100%;
    }
    .AdvancedSearch_input_clear {
      background: url('../../assets/img/GJSS/QC.png') no-repeat 100%;
    }
  }

  .AdvancedSearch_main {
    height: 1444px;
    overflow-y: auto;
    .ConditionsSearch {
      .ConditionsSearch_location {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        margin-bottom: 10px;
        box-sizing: border-box;
        .ConditionsSearch_location_text {
          color: #fff;
          font-family: '微软雅黑';
          font-size: 26px;
        }

        .ConditionsSearch_location_Dropdown {
          position: relative;
          .ConditionsSearch_location_Dropdown_head {
            width: 390px;
            height: 50px;
            border-radius: 5px;
            border: 2px solid rgb(77, 80, 94);
            background-color: rgb(39, 39, 41);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 21px 0 13px;
            box-sizing: border-box;

            & > span {
              color: #fff;
              font-family: '微软雅黑';
              font-size: 26px;
            }

            .ConditionsSearch_location_Dropdown_head_icon {
              width: 20px;
              height: 12px;
              background: url('../../assets/img/GJSS/X.png') no-repeat 100%;
            }
          }

          .ConditionsSearch_location_Dropdown_list {
            position: absolute;
            top: 50px;
            left: 0px;
            z-index: 9;
            width: 100%;
            height: 252px;
            border: solid 2px rgb(77, 80, 94);
            background-color: rgb(39, 39, 41);
            border-top: none;
            box-sizing: border-box;
            overflow-y: auto;

            & > li {
              width: 100%;
              height: 48px;
              line-height: 48px;
              color: #fff;
              font-family: '微软雅黑';
              font-size: 28px;
              padding-left: 13px;
              box-sizing: border-box;

              &:hover {
                background-color: #0489ec;
              }
            }
          }
        }

        .ConditionsSearch_location_button {
          width: 160px;
          height: 50px;
          color: #fff;
          font-family: '微软雅黑';
          font-size: 24px;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #189bfa;
          border-radius: 10px;
          padding: 0 16px;
          box-sizing: border-box;

          .ConditionsSearch_location_button_icon {
            width: 24px;
            height: 24px;
            background: url('../../assets/img/GJSS/TJTJ.png') no-repeat 100%;
          }
        }
      }

      .ConditionsSearch_condition {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        margin-bottom: 10px;
        box-sizing: border-box;

        .ConditionsSearch_condition_text {
          color: #fff;
          font-family: '微软雅黑';
          font-size: 26px;
        }

        .ConditionsSearch_condition_Dropdown {
          position: relative;
          .ConditionsSearch_condition_Dropdown_head {
            width: 190px;
            height: 50px;
            border-radius: 5px;
            border: 2px solid rgb(77, 80, 94);
            background-color: rgb(39, 39, 41);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 21px 0 13px;
            box-sizing: border-box;

            & > span {
              color: #fff;
              font-family: '微软雅黑';
              font-size: 26px;
            }

            .ConditionsSearch_condition_Dropdown_head_icon {
              width: 20px;
              height: 12px;
              background: url('../../assets/img/GJSS/X.png') no-repeat 100%;
            }
          }

          .ConditionsSearch_condition_Dropdown_list {
            position: absolute;
            top: 50px;
            left: 0px;
            z-index: 9;
            width: 100%;
            height: 252px;
            border: solid 2px rgb(77, 80, 94);
            background-color: rgb(39, 39, 41);
            border-top: none;
            box-sizing: border-box;
            overflow-y: auto;

            & > li {
              width: 100%;
              height: 48px;
              line-height: 48px;
              color: #fff;
              font-family: '微软雅黑';
              font-size: 28px;
              padding-left: 13px;
              box-sizing: border-box;

              &:hover {
                background-color: #0489ec;
              }
            }
          }

          .ConditionsSearch_condition_Dropdown_list2 {
            height: 452px;
          }
        }

        .ConditionsSearch_condition_button {
          width: 160px;
          height: 50px;
          color: #fff;
          font-family: '微软雅黑';
          font-size: 24px;
          font-weight: bold;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #189bfa;
          border-radius: 10px;
          padding: 0 35px;
          box-sizing: border-box;

          .ConditionsSearch_conditionbutton_icon {
            width: 24px;
            height: 24px;
            background: url('../../assets/img/GJSS/SC.png') no-repeat 100%;
          }
        }
      }

      .ConditionsSearch_button {
        padding: 0 20px 0 88px;
        margin-bottom: 10px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        & > div {
          width: 270px;
          height: 50px;
          background: #189bfa;
          color: #fff;
          font-family: '微软雅黑';
          font-size: 24px;
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 10px;
        }

        .ConditionsSearch_button_search {
          & > i {
            width: 26px;
            height: 26px;
            background: url('../../assets/img/GJSS/SS_B.png') no-repeat 100%;
            margin-right: 15px;
          }
        }

        .ConditionsSearch_button_clear {
          & > i {
            width: 26px;
            height: 26px;
            background: url('../../assets/img/GJSS/LJT.png') no-repeat 100%;
            margin-right: 15px;
          }
        }
      }
    }

    .SpaceCearch {
      padding: 0 20px;
      box-sizing: border-box;
      .SpaceCearch_UG {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        & > div {
          color: #fff;
          font-family: '微软雅黑';
          font-size: 26px;
          padding-left: 9px;
        }

        & > input {
          width: 490px;
          height: 50px;
          background: #272729;
          color: #fff;
          font-size: 26px;
          border: solid 2px #4d505e;
          padding: 0px 19px 0px 12px;
          box-sizing: border-box;
        }
      }

      .SpaceCearch_location {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .SpaceCearch_location_text {
          color: #fff;
          font-family: '微软雅黑';
          font-size: 26px;
          padding-left: 10px;
        }

        .SpaceCearch_location_Dropdown {
          position: relative;
          .SpaceCearch_location_Dropdown_head {
            width: 490px;
            height: 50px;
            border-radius: 5px;
            border: 2px solid rgb(77, 80, 94);
            background-color: rgb(39, 39, 41);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 21px 0 13px;
            box-sizing: border-box;

            & > span {
              color: #fff;
              font-family: '微软雅黑';
              font-size: 26px;
            }

            .SpaceCearch_location_Dropdown_head_icon {
              width: 20px;
              height: 12px;
              background: url('../../assets/img/GJSS/X.png') no-repeat 100%;
            }
          }

          .SpaceCearch_location_Dropdown_list {
            position: absolute;
            top: 50px;
            left: 0px;
            z-index: 9;
            width: 100%;
            height: 252px;
            border: solid 2px rgb(77, 80, 94);
            background-color: rgb(39, 39, 41);
            border-top: none;
            box-sizing: border-box;
            overflow-y: auto;

            & > li {
              width: 100%;
              height: 48px;
              line-height: 48px;
              color: #fff;
              font-family: '微软雅黑';
              font-size: 28px;
              padding-left: 13px;
              box-sizing: border-box;

              &:hover {
                background-color: #0489ec;
              }
            }
          }
        }
      }

      .SpaceCearch_button {
        padding: 0 0px 0 78px;
        margin-bottom: 10px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        & > div {
          width: 270px;
          height: 50px;
          background: #189bfa;
          color: #fff;
          font-family: '微软雅黑';
          font-size: 24px;
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 10px;
        }

        .SpaceCearch_button_search {
          & > i {
            width: 26px;
            height: 19px;
            background: url('../../assets/img/GJSS/QD.png') no-repeat 100%;
            margin-right: 15px;
          }
        }

        .SpaceCearch_button_clear {
          & > i {
            width: 26px;
            height: 26px;
            background: url('../../assets/img/GJSS/LJT.png') no-repeat 100%;
            margin-right: 15px;
          }
        }
      }
    }
  }
  @oddBg: rgba(0, 0, 0, 0.2);
  @evenBg: rgba(43, 48, 60, 0.9);

  // 修改el-tree
  .custom-el-tree-header {
    display: flex;
    align-items: center;
    height: 70px;
    min-height: 70px;
    background-color: rgba(43, 48, 60, 0.9);
    .custom-el-tree-header__text:nth-child(1) {
      color: #7e8ca5;
      font-size: 28px;
      width: 520px;
      padding-left: 86px;
      box-sizing: border-box;
    }
    .custom-el-tree-header__text:nth-child(2) {
      flex: 1;
      color: #7e8ca5;
      font-size: 28px;
    }
  }
  /deep/ .custom-el-tree.el-tree {
    // background-color: rgba(43, 48, 60, 0.9);
    background: #00000000;
    height: 1316px;
    overflow-y: auto;
    .el-tree-node:nth-child(odd) > .el-tree-node__content {
      height: 60px;
      //   background: @oddBg;
      background: #00000000;
    }
    .el-tree-node:nth-child(even) > .el-tree-node__content {
      height: 60px;
      //   background: @evenBg;
      background: #00000000;
    }
    .el-tree-node__expand-icon {
      font-size: 28px;
      margin-left: 75px;
      pointer-events: none;
    }
    .el-tree-node.is-current > .el-tree-node__content,
    .el-tree-node.is-expanded > .el-tree-node__content {
      background: rgba(24, 155, 250, 0.1);
      .el-icon-caret-right {
        color: #54b7ff;
      }
      .el-icon-caret-right.is-leaf {
        color: transparent;
      }
      .custom-el-tree-node {
        .text,
        .num,
        .category {
          color: #54b7ff;
        }
      }
    }
    .custom-el-tree-node {
      flex: 1;
      display: flex;
      justify-content: space-around;
      align-items: center;
      // width: 100%;
      color: #fff;
      font-size: 28px;
      .text {
        flex: 1;
        text-align: left;
      }
      .category {
      }
      .num {
        flex: 1;
        text-align: center;
      }
    }
  }

  .AdvancedSearch_footer {
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    height: 75px;
    line-height: 75px;
    padding-left: 20px;
    border-top: 2px solid rgba(146, 172, 186, 0.65);
    box-sizing: border-box;
    color: #999999;
    font-family: '微软雅黑';
    font-size: 26px;
  }
}
</style>